/**
 * 测试期免费档临时额度说明（正式收费上线后恢复 1GB / 45 分钟）。
 * 运行时限额以 DB quota_plan（FREE）为准。
 */
export const FREE_QUOTA_FORMAL = {
  maxFileMb: 1024,
  maxDurationMin: 45,
};

/** Banner / 定价 / 内测说明共用短文案 */
export const FREE_QUOTA_BETA_NOTICE =
  '测试期免费档临时提升为单文件 1.5GB、时长 60 分钟；正式收费上线后将恢复为 1GB / 45 分钟。';
